import { AppAction } from '../appActions';
import { LoginAction, loginSuccess } from '../Login/LoginAction';
import { SettingAction, languageSelect } from '../Settings/SettingsActions';
import { getCurrentLanguage, setCurrentLanguage } from '../currentLanguage';
import {
  localStorageGet,
  localStorageRemove,
  localStorageSet,
} from '../util/localStorage';

import { CommonAction } from '../commonAction';
import { ListViewAction } from '../ListView/ListViewActions';
import { LocalStorageKey } from '../util/LocalStorageKey';
import { Middleware } from 'redux';
import { attemptLoadTeams } from '../ChooseTeam/ChooseTeamAction';

export const persistAndInit: Middleware = (_store) => (dispatch) => {
  return (
    action:
      | AppAction
      | LoginAction
      | SettingAction
      | CommonAction
      | ListViewAction
  ) => {
    switch (action.type) {
      // find out what things needs to be loaded from localStorage
      case 'RESUME_SESSION': {
        const token = localStorageGet(LocalStorageKey.token);
        if (token) {
          const userId = localStorageGet(LocalStorageKey.userId);
          const userType = localStorageGet(LocalStorageKey.userType);
          const fullName = localStorageGet(LocalStorageKey.fullName);
          if (userId !== null && userType !== null && fullName !== null) {
            dispatch(loginSuccess(token, userType, userId, fullName));
            void dispatch(attemptLoadTeams());
          }
        }
        // set init lang
        dispatch(languageSelect(getCurrentLanguage()));
        setCurrentLanguage(getCurrentLanguage());
        break;
      }
      case 'LOGIN_SUCCESS':
        localStorageSet(LocalStorageKey.userId, action.userId);
        localStorageSet(LocalStorageKey.userType, action.userType);
        localStorageSet(LocalStorageKey.fullName, action.fullName);
        break;
      case 'LOGOUT':
        // Removal of token is handled in fetcher
        localStorageRemove(LocalStorageKey.userId);
        localStorageRemove(LocalStorageKey.userType);
        localStorageRemove(LocalStorageKey.fullName);
        break;
      // Persist language select
      case 'LANGUAGE_SELECT':
        setCurrentLanguage(action.language); // make sure to also setCurrentLanguage
        break;
      case 'CHANGE_TEAM':
        localStorageSet(LocalStorageKey.currentTeam, action.teamId);
        break;
    }
    return dispatch(action);
  };
};
